var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Children } from "react";
import classNames from "classnames";
// A importer si on veut utiliser le DSFR, sinon on dev nous même
import "@gouvfr/dsfr/dist/component/form/form.css";
import "@gouvfr/dsfr/dist/component/input/input.css";
import "@gouvfr/dsfr/dist/component/button/button.css";
var ButtonGroup = function (props) {
    var _a;
    var children = props.children, className = props.className, size = props.size, isInlineFrom = props.isInlineFrom, iconPosition = props.iconPosition, reverse = props.reverse, equisize = props.equisize, align = props.align, remainingProps = __rest(props, ["children", "className", "size", "isInlineFrom", "iconPosition", "reverse", "equisize", "align"]);
    var _className = classNames("fr-btns-group", (_a = {},
        _a["fr-btns-group--".concat(size)] = size && size !== "md",
        _a["fr-btns-group--".concat(align)] = align && align !== "left",
        _a["fr-btns-group--icon-".concat(iconPosition)] = iconPosition,
        _a["fr-btns-group--inline"] = isInlineFrom === "xs",
        _a["fr-btns-group--inline-".concat(isInlineFrom)] = isInlineFrom && isInlineFrom !== "xs",
        _a["fr-btns-group--inline-reverse"] = reverse,
        _a["fr-btns-group--equisized"] = equisize,
        _a), className);
    var content = Children.toArray(children).map(function (child, index) { return (React.createElement("li", { key: index }, child)); });
    return (React.createElement("ul", __assign({ className: _className }, remainingProps), content));
};
export default ButtonGroup;
